import { useDropdownAnimation, useFloating, useOnClickOutside } from "@microfrontends/react-components/components/hooks"
import InfoIcon from "../Page/ProfileSettings/images/InfoIcon"
import { IconButton, PreviewJobSeekingStatus, PreviewJobStatusWrapper, PreviewTitle, PreviewUserInfo, UserAvatar, UserInfo } from "./PreviewJobStatus.css"
import { useEffect, useRef, useState } from "react"
import { colors, ELanguage, Typography } from "@microfrontends/react-components"
import { useStore } from "../../store"
import { TagNew } from "../Page/ProfileSettings/style.css"
import { CloseIcon } from "@microfrontends/react-components/components/Images"
import DefaultAvatarIcon from "../Global/MainLayout/SideNavigation/images/DefaultAvatarIcon"
import { isMobile } from "../../helpers/util"

const PreviewJobStatus = () => {
    const { state } = useStore()
    const { user, t } = state
    const [isShow, setIsShow] = useState<boolean>(false)

    const { refs, context, FloatingPortal } = useFloating({
        placement: 'top',
        position: 'fixed',
        config: {
            useWindowAsFlippingContainer: false,
            isFlip: false,
            detectHidden: false
        }
    })

    useEffect(() => {
        const onClick = (event: MouseEvent) => {
            const el: HTMLElement | null = refs.popup?.current
            if (!el || el.contains(event.target as Node)) {
                return
            }
            if (!isShow) {
                return
            }
            setIsShow(false)
        }

        window.addEventListener('mouseup', onClick)
        return () => {
            window.removeEventListener('mouseup', onClick)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShow])

    const dropdownStyle: React.CSSProperties = {
        position: context.position,
        top: context.y,
        left: context.x,
        display: context.isReferenceHidden ? 'none' : 'block'
    }

    const { isMounted, styles } = useDropdownAnimation(isShow, context.placement)
    const fullName =
        state.langCode === ELanguage.VI
            ? `${user?.lastName} ${user?.firstName}`
            : `${user?.firstName} ${user?.lastName}`


    return (
        <>
            <IconButton ref={refs.setReference} onMouseOver={() => setIsShow(true)} onMouseOut={() => setIsShow(false)}>
                <InfoIcon onClick={() => setIsShow(!isShow)} />
            </IconButton>
            <FloatingPortal>
                {isMounted ? (
                    <PreviewJobStatusWrapper
                        ref={refs.setPopup}
                        style={dropdownStyle}
                        data-floating-placement={context.placement}
                    >
                        <PreviewJobSeekingStatus style={styles}>
                            <PreviewTitle>
                                <Typography name='body' size='medium' color={colors.grey[20]}><div dangerouslySetInnerHTML={{ __html: t("Your searchable profile will be more outstanding with <strong>\"Open to work\"</strong> tag") }} /></Typography>
                                {isMobile() ? (
                                    <IconButton onClick={() => setIsShow(false)}>
                                        <CloseIcon />
                                    </IconButton>
                                ) : null}
                            </PreviewTitle>
                            <PreviewUserInfo>
                                {user?.profilePicture ? (
                                    <UserAvatar src={user?.profilePicture} />
                                ) : (
                                    <DefaultAvatarIcon width={60} />
                                )}

                                <UserInfo>
                                    <Typography name='title' size='extraLarge' style={{ display: 'flex', alignItems: 'center' }}>{fullName} <TagNew name='label' size='small' style={{ marginTop: 1 }}>{t('Open to work')}</TagNew></Typography>
                                    <Typography style={{ marginTop: 8 }}>{user?.jobTitle}</Typography>
                                </UserInfo>
                            </PreviewUserInfo>
                        </PreviewJobSeekingStatus>
                    </PreviewJobStatusWrapper>
                ) : <></>}
            </FloatingPortal>
        </>
    )
}

export default PreviewJobStatus

